import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide001CognitiveDevelopment() {
  return <KbGuidePage slug="guide-001-cognitive-development" />;
}

(Guide001CognitiveDevelopment as unknown as { path: string }).path = "/guides/cognitive-development";
